import CaseCard from './CaseCard.vue';
import Empty from 'components/Empty';
import { ElTabPane, ElTabs } from 'element-plus';
export default {
  props: {
    caseList: {
      type: Array,
      default() {
        return [];
      }
    },
    pageInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    sortKey: {
      type: String || Number
    }
  },
  components: {
    CaseCard,
    Empty,
    ElTabPane,
    ElTabs
  },
  data() {
    return {
      activeName: 'building',
      courseList: [],
      courseCategorys: [],
      watchType: 1,
      // 1 倒叙 2 正序
      quoteType: 1,
      creatType: 1
    };
  },
  computed: {},
  methods: {
    handleClick() {},
    sortHandle(type) {
      switch (type) {
        case 'view':
          this.watchType = this.watchType == 1 ? 2 : 1;
          this.$emit('sort', {
            sortType: this.watchType,
            sortKey: 1
          });
          break;
        case 'quote':
          this.quoteType = this.quoteType == 1 ? 2 : 1;
          this.$emit('sort', {
            sortType: this.quoteType,
            sortKey: 2
          });
          break;
        case 'creatTime':
          this.creatType = this.creatType == 1 ? 2 : 1;
          this.$emit('sort', {
            sortType: this.creatType,
            sortKey: 3
          });
          break;
        default:
          return;
      }
    },
    pageChange(e) {
      console.log(e);
      this.$emit('pageChange', e);
    }
  }
};